import React from 'react';
import { Route } from 'react-router-dom';
import PrivateRoute from 'src/routes/PrivateRoute';
import {
  ContactCaptureAnalyticsPage,
  ContactCaptureBuilderPage,
  ContactCaptureListPage,
} from '../pages';

const protect = (page: React.ReactNode) => (
  <PrivateRoute>{page}</PrivateRoute>
);

export const routes = (
  <>
    <Route path="/contact-capture" element={protect(<ContactCaptureListPage />)} />
    <Route path="/contact-capture/new" element={protect(<ContactCaptureBuilderPage />)} />
    <Route path="/contact-capture/:id/edit" element={protect(<ContactCaptureBuilderPage />)} />
    <Route path="/contact-capture/:id/analytics" element={protect(<ContactCaptureAnalyticsPage />)} />
  </>
);
